import React, { useState } from "react";
import { Button, Input, useToast } from "@chakra-ui/react";
import { Dropdown } from "primereact/dropdown";
import { AddDeviceAds } from "../../../../../../../../core/Services";
import { Message } from "primereact/message";

export default function AddData({
  uniqueCustomerId,
  selectedMonth,
  selectedCustomer,
  DataTypes,
  updateTableData
}) {
  
  const [value, setValue] = useState("");
  const [cost, setCost] = useState("");
  const [show, setShow] = useState("");
  const [error, setError] = useState(false);
  const toast = useToast();
  const [selectedDataType, setSelectedDataType] = useState("");
  

  const handleSave = () => {
    if (!selectedCustomer || !selectedMonth || !value) {
      setError(true);
      toast({
        title: "Hata",
        description: "Lütfen tüm alanları doldurunuz.",
        status: "error",
        duration: 3000,
        position: "top-right",
        isClosable: true,
      });
      return;
    }

    AddDeviceAds(
      uniqueCustomerId,
      selectedDataType,
      value,
      cost,
      selectedMonth,
      show
    )
      .then((response) => {
        if (response.message === "Hata") {
          toast({
            title: "Hata",
            description: "Kullanıcya Ait Bu Ay Verisi Zaten Mevcut",
            status: "error",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
        } else {
          setValue("");
          setCost("");
          setShow("");
          setSelectedDataType("");
         
          setError(false);

          toast({
            title: "Başarılı",
            description: "Veri başarılı bir şekilde kaydedildi.",
            status: "success",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
          updateTableData();
        }
      })
      .catch((error) => {
        console.error("Backend'e gönderme hatası:", error);
        toast({
          title: "Hata",
          description: "Veri gönderilirken bir hata oluştu.",
          status: "error",
          duration: 3000,
          position: "top-right",
          isClosable: true,
        });
      });
  };

  return (
    <div>
      <div className="mt-2">Veri Tipi :</div>
      <div>
        <Dropdown
          style={{
            border: `2px solid ${error && !selectedDataType ? "red" : ""}`,
            borderRadius: "1rem",
            width: "30rem",
          }}
          value={selectedDataType}
          options={DataTypes?.map((type) => ({
            label: type.name,
            value: type.value,
          }))}
          onChange={(e) => setSelectedDataType(e.value)}
          placeholder="Veri Adı Seçiniz"
        />
      </div>
      <div className="mt-2">Tıklamalar :</div>
      <div>
        <Input
          placeholder="Tıklamalar"
          w="30rem"
          name="value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>

      <div className="mt-2">Gösterim Sayısı : </div>
      <div>
        <Input
          placeholder="Gösterim Sayısı"
          w="30rem"
          value={show}
          onChange={(e) => setShow(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>
      <div className="mt-2">Maliyet : </div>
      <div>
        <Input
          placeholder="Maliyet"
          w="30rem"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>

      <div className="mt-5 flex justify-content-end">
        <Button onClick={handleSave}> Kaydet</Button>
      </div>
      <Message className="mt-4 w-full" severity="info" text="Google Ads" />
    </div>
  );
}
